<template>
  <div @click="click">
    <!-- 用户信息 -->
    <div v-if="!avatar" :class="['user-wrapper', { 'is-login': isLogin }]">
      <i class="user-icon icon-outline_personalcenter"></i>
    </div>
    <!-- 什么情况会使用到？ -->
    <img v-else class="header-logo" :src="avatar" />
  </div>
</template>

<script>
export default {
  components: {},
  name: 'UserAvatar',
  props: {
    isLogin: {
      type: [Boolean, Number],
      default: false,
    },
    avatar: {
      type: String,
      default: '',
    },
  },
  computed: {},
  data() {
    return {
      personalCenterShow: false,
      sideList: [{ tag: 'help', content: 'help', icon: 'icon-outlined_help' }],
    };
  },
  mounted() {},
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/index.scss';
.user-wrapper {
  margin-right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  line-height: 26px;
  margin-right: 8px;
  border: 1px solid;
  font-size: 20px;
  // ??????
  border-color: rgba(255, 122, 69, 0.5);

  [data-site-theme='dark'] & {
    border-color: #FFFFFF;
  }

  .user-icon {
    font-size: 16px;
    @include font-color();

    [data-site-theme='dark'] & {
      color: #FFFFFF;
    }
  }

  &.is-login {
    border: none;
    @include act-tag-bg-color();

    .user-icon {
      @include font-color();
    }
  }
}
</style>
